import * as Sentry from '@sentry/angular';
import { enableProdMode, NgModuleRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { PORTAL_RELEASE_VERSION } from '@app-core/constants/constants';
import { CLIENT_CONFIG } from '@config/config';
import {
  GEOTAB_DATABASE,
  GEOTAB_STATE,
  performInitialNavigationForGeotab,
  subscribeNavigateToListnerForGeotab,
} from './app/geotab/geotab-utils';

if (environment.production) {
  enableProdMode();

  if (!Boolean(CLIENT_CONFIG.disableSentry) && environment?.env === 'prod') {
    Sentry.init({
      release: PORTAL_RELEASE_VERSION,
      sampleRate: 0.5,
      dsn: 'https://ce6035b77b99036d6c97c2898d1d0bcd@o4507763074138112.ingest.us.sentry.io/4507763076038656',
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      // Performance Monitoring
      tracesSampleRate: 0.1, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
      tracePropagationTargets: [/^https:\/\/*.lightmetrics\.co\//],
      // Session Replay
      replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 0.1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
  }
}

if (environment.isGeotabEnv) {
  let ngModuleRef: NgModuleRef<AppModule> | null = null;

  window.addEventListener('rideview:bootstrap-app-module', (event) => {
    if (ngModuleRef) return;
    const main = document.querySelector('main');
    const appRoot = main?.querySelector('app-geotab-root');
    if (!appRoot) main?.appendChild(document.createElement('app-geotab-root'));
    platformBrowserDynamic([
      { provide: GEOTAB_STATE, useValue: (event as CustomEvent).detail.state },
      { provide: GEOTAB_DATABASE, useValue: (event as CustomEvent).detail.database || '' },
    ])
      .bootstrapModule(AppModule)
      .then((_) => {
        ngModuleRef = _;
        subscribeNavigateToListnerForGeotab(ngModuleRef);
        performInitialNavigationForGeotab(ngModuleRef);
      })
      .catch((err) => console.error(err));
  });

  window.addEventListener('rideview:destroy-app-module', () => {
    ngModuleRef?.destroy();
    ngModuleRef = null;
  });
} else {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(() => {
      if ('serviceWorker' in navigator && environment.production) {
        navigator.serviceWorker.register('/ngsw-worker.js');
      }
    })
    .catch((err) => console.log(err));
}
